import React, { useEffect, useState } from 'react';
import './App.css';
import LoginDialog from './components/login/LoginDialog';
import { UserContext, useUserContext } from './contexts/userContext';
import PersistentDrawerLeft from './components/PersistentDrawerLeft';
import AlumnosList from './components/Alumnos/Alumnos';
import { createTheme, ThemeProvider } from '@mui/material';
import Grupos from './components/Grupos/Grupos';
import Asistencia from './components/Asistencia/Asistencia';
import { Cuotas } from './components/Cuotas/Cuotas';
import { Usuarios } from './components/Usuarios/Usuarios';
import { Reportes } from './components/Reportes/Reportes';
import { ReporteIngresos } from './components/Reportes/ReporteIngresos';
import ReporteAsistencia from './components/Asistencia/ReporteAsistencia';
import { Torneos } from './components/Torneos/Torneos';

const theme = createTheme({
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: () => ({
          backgroundColor: '#1876d2',
          color: 'white',
        }),
      },
    },
  },
});


function App() {
  const userContext = useUserContext();
  const [currentlySelected, setCurrentlySelected] = useState<string | null>(localStorage.getItem('screen') || null);

  useEffect(() => {
    // save curren screen on cookie
    if (currentlySelected) localStorage.setItem('screen', currentlySelected);
  }, [currentlySelected]);

  useEffect(() => {
    if (!currentlySelected && userContext.user) {
      if (userContext.user.roles?.includes('asistencia')) setCurrentlySelected('asistencia');
      else setCurrentlySelected(userContext.user?.roles?.[0] ?? null);
    }
  }, [userContext.user]);
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <UserContext.Provider value={userContext}>
          <PersistentDrawerLeft setCurrentlySelected={setCurrentlySelected}>
            {currentlySelected === 'asistencia' && <Asistencia />}
            {currentlySelected === 'ver datos' && <AlumnosList />}
            {currentlySelected === 'admin usuarios' && <Usuarios />}
            {currentlySelected === 'admin torneos' && <Torneos />}
            {currentlySelected === 'admin grupos' && <Grupos />}
            {currentlySelected === 'admi cuotas' && <Cuotas />}
            {currentlySelected === 'ver alertas' && <Reportes />}
            {currentlySelected === 'planilla asistencia' && <ReporteAsistencia />}
            {currentlySelected === 'ver ingresos' && <ReporteIngresos />}
          </PersistentDrawerLeft>
          <LoginDialog />
        </UserContext.Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
